var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5F9AE4",
    fillRule: "evenodd",
    d: "M23.4423419,59.7703571 L15.5,54.5532143 L7.55765811,59.7703571 C7.06518077,60.0935714 6.42721478,60.0735714 5.95516927,59.7210714 C5.48312376,59.3682143 5.27633964,58.7557143 5.43556693,58.1832143 L7.92226042,49.2482143 L0.499520866,42.8871429 C0.0619980845,42.5121429 -0.108149664,41.9060714 0.0693958127,41.3535714 C0.246941289,40.8014286 0.736600441,40.4128571 1.30798688,40.3714286 L10.2113289,39.7217857 L14.2184317,30.8346429 C14.4477612,30.3260714 14.9486931,30 15.5,30 C16.0513069,30 16.5522388,30.3260714 16.7815683,30.8346429 L20.7886711,39.7217857 L29.6920131,40.3714286 C30.2633996,40.4128571 30.7530587,40.8014286 30.9306042,41.3535714 C31.1081497,41.9060714 30.9380019,42.5121429 30.5004791,42.8871429 L23.0777396,49.2482143 L25.5644331,58.1832143 C25.7236604,58.7557143 25.5168762,59.3682143 25.0448307,59.7210714 C24.7968307,59.9064286 24.5030352,60 24.2081829,60 C23.942217,60 23.6758987,59.9235714 23.4423419,59.7703571 Z",
    transform: "translate(0 -30)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlue);
export default __webpack_public_path__ + "static/media/star-blue.321ddf2a8faf11b1ca9d4c3716a33611.svg";
export { ForwardRef as ReactComponent };